var _excluded = ["normalizedItems", "tooltip", "selectedKeys", "defaultSelectedKeys", "disabledKeys", "showItemIcons", "actions", "UNSAFE_className", "onChange", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useMemo, createElement as _createElement } from 'react';
import cl from 'classnames';
import { normalizeTooltipOptions, useRenderNormalizedItem, useStringifiedMultiSelection } from "../utils/index.js";
import { ListViewWrapper } from "./ListViewWrapper.js";
/**
 * ListView supporting normalized item data. This component mostly exists to
 * decouple some of the logic needed to support table data. Specifically it
 * handles item rendering configurations as well as converting selection keys
 * to / from strings. This makes it easier to test logic in isolation without
 * a dependency on JS apis (e.g. in the Styleguide).
 *
 * Note that This component will usually not be used directly. Instead, it is
 * recommended to use
 * - `@deephaven/components`'s `ListView` for non-table data sources
 * - `@deephaven/jsapi-components`'s `ListView` for table data sources
 */
export function ListViewNormalized(_ref) {
  var normalizedItems = _ref.normalizedItems,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? true : _ref$tooltip,
    selectedKeys = _ref.selectedKeys,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    disabledKeys = _ref.disabledKeys,
    showItemIcons = _ref.showItemIcons,
    actions = _ref.actions,
    UNSAFE_className = _ref.UNSAFE_className,
    onChange = _ref.onChange,
    onSelectionChange = _ref.onSelectionChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var tooltipOptions = useMemo(() => normalizeTooltipOptions(tooltip, 'bottom'), [tooltip]);
  var renderNormalizedItem = useRenderNormalizedItem({
    itemIconSlot: 'illustration',
    // Descriptions introduce variable item heights which throws off setting
    // viewport on windowed data. For now not going to implement description
    // support in Picker.
    // https://github.com/deephaven/web-client-ui/issues/1958
    showItemDescriptions: false,
    showItemIcons,
    tooltipOptions,
    actions
  });

  // Spectrum doesn't re-render if only the `renderNormalizedItems` function
  // changes, so we create a key from its dependencies that can be used to force
  // re-render.
  var forceRerenderKey = "".concat(showItemIcons, "-").concat(tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.placement);
  var _useStringifiedMultiS = useStringifiedMultiSelection({
      normalizedItems,
      selectedKeys,
      defaultSelectedKeys,
      disabledKeys,
      onChange: onChange !== null && onChange !== void 0 ? onChange : onSelectionChange
    }),
    selectedStringKeys = _useStringifiedMultiS.selectedStringKeys,
    defaultSelectedStringKeys = _useStringifiedMultiS.defaultSelectedStringKeys,
    disabledStringKeys = _useStringifiedMultiS.disabledStringKeys,
    onStringSelectionChange = _useStringifiedMultiS.onStringSelectionChange;
  return /*#__PURE__*/_createElement(ListViewWrapper
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread(_objectSpread({}, props), {}, {
    UNSAFE_className: cl('dh-list-view-normalized', UNSAFE_className),
    key: forceRerenderKey,
    items: normalizedItems,
    selectedKeys: selectedStringKeys,
    defaultSelectedKeys: defaultSelectedStringKeys,
    disabledKeys: disabledStringKeys,
    onSelectionChange: onStringSelectionChange
  }), renderNormalizedItem);
}
export default ListViewNormalized;
//# sourceMappingURL=ListViewNormalized.js.map